// Store danh mục mã thống kê
import {defineStore} from 'pinia';
import {ModuleStatistic} from '../moduleConst';
import StatisticAPI from '@/apis/di/statisticAPI';
import {BaseDictionaryStore} from './../baseDictionaryStore';
import i18nMonitor from '@/i18ns/vi/monitor/i18nMonitor';

const statisticStore = new BaseDictionaryStore(StatisticAPI);

export const useStatisticStore = defineStore(ModuleStatistic, {
  state: () => ({
    ...statisticStore.state,
    _config: {
      key: 'statistic_id',
      code: 'statistic_code',
      name: 'statistic_name',
      table: 'di_statistic',
      moduleName: i18nMonitor.ScreenName.DIStatistic,
      quickFollow: 'active',
      defaultSort: 'statistic_code',
    },
    moduleName: 'statistic',
  }),
  actions: {...statisticStore.action},
  getters: {
    ...statisticStore.getters,
  },
});
